export default "__VITE_ASSET__71yKYlxT__"